export default "__VITE_ASSET__BNhtq6nf__"